import { Component, inject,computed } from '@angular/core';
import { TenantSettingsService } from '../../../services/tenant-settings.service';

@Component({
  selector: 'ams-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  readonly tenantSettings = inject(TenantSettingsService);
  readonly branding = this.tenantSettings.branding;
  readonly siteFooter = computed(() => {
    const footer = this.branding().siteFooter;
    return footer ? footer.replace('{year}', new Date().getFullYear().toString()) : '';
  });
}
